import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const createBooking = async (hotelId, roomId, bookingData, number, medium, type) => {
    try {
        const payload = {
            ...bookingData,
            number,
            medium,
        };

        const response = await api.post(
            `/hotels/${hotelId}/rooms/${roomId}/book/${type}`,
            payload
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to create booking');
    }
};

export const getUserBookings = async () => {
    try {
        const response = await api.get(`/user/bookings`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch bookings');
    }
};

export const cancelUserBooking = async (hotelId, roomId, bookingId) => {
    try {
        const response = await api.put(
            `/hotels/${hotelId}/rooms/${roomId}/bookings/${bookingId}/cancel`,
            {}
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to cancel booking');
    }
};

export const createWalkInBooking = async(formData) => {
    try {
        const response = await api.post(
            `/walk-in-booking`,
            formData,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to create walk-in booking');
    }
};
